import $ from 'jquery'
import { useEffect, useState } from 'react'
import NavBar from '../structure/NavBar'
import { useDispatch, useSelector } from 'react-redux'
import { NavBarTop } from '../structure/NavBarTop'
import {
  updateTopHeader,
  uplodateLoading
} from '../../redux/features/common/commonSlice'
import { selectPermission, selectUserData } from '../../redux/features/common/selectors'
import InsufficientPermission from '../custom/InSufficientPermission'
import DashboardOverview from './DashboardOverview'

export const Dashboard = () => {
  const [enable, setEnable] = useState(false)
  const dispatch = useDispatch()
  const userData = useSelector(selectUserData)
  const userPermisiions = useSelector(selectPermission)

  useEffect(() => {
    $('body').removeClass('bg-default')
    dispatch(updateTopHeader('Dashboard'))
    dispatch(uplodateLoading(false))
  }, [dispatch])

  useEffect(() => {
    if (userData.admin) {
      setEnable(true)
      return
    }
    const dashboardModule = userPermisiions?.modules?.find(
      (m) => m.moduleId === '1'
    )
    const canView = dashboardModule?.permissions?.find(
      (p) => p.name === 'VIEW'
    )?.isEnable
    setEnable(!!canView)
  }, [userData.admin, userPermisiions])

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        {enable ? (
          <DashboardOverview />
        ) : (
          <div className='header'>
            <div className='logo'>
              <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'>
                <div className='container-fluid'>
                  <div className='header-body'>
                    <div className='row' style={{ justifyContent: 'center' }}>
                      <InsufficientPermission />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
